import { PAYMENT_MODE } from './consts';

export const checkRazorPayValidation = paymentData => {
  if (!paymentData) {
    return;
  }

  if (!paymentData.error) {
    return;
  }

  if (!paymentData.success) {
    return;
  }

  if (!paymentData.paymentMode) {
    return;
  }

  if (!paymentData.paymentObject) {
    return;
  }

  const razorPayData = paymentData.paymentObject;

  if (!razorPayData.order_id) {
    return;
  }

  if (!razorPayData.key) {
    return;
  }

  if (!razorPayData.amount) {
    return;
  }
  if (parseInt(razorPayData.amount) <= 0) {
    return;
  }

  return true;
};

export const validatePayload = paymentData => {
  if (!paymentData) {
    return;
  }

  if (!paymentData.error) {
    return;
  }

  if (!paymentData.success) {
    return;
  }

  if (!paymentData.paymentMode) {
    return;
  }

  if (!paymentData.paymentObject) {
    return;
  }

  const razorPayData = paymentData.paymentObject;

  if (!paymentData.paymentObject.order_id) {
    return;
  }

  if (paymentData.paymentMode === PAYMENT_MODE.CASH) {
    if (!razorPayData.amount) {
      return;
    }
    if (parseInt(razorPayData.amount) <= 0) {
      return;
    }
  } else if (paymentData.paymentMode === PAYMENT_MODE.MILES) {
    if (!paymentData.paymentObject.interMiles) {
      return;
    }
  }
  return true;
};
